export type DateRangeConfig = {
  from?: string,
  to?: string,
}

export function isDateRangeConfig(config: unknown): config is DateRangeConfig {
  return typeof config === 'object' && config !== null && config !== undefined
}